function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null, ".st0{fill:#2d2d48}");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M113.291 21.183c6.547.16 11.477 1.997 14.791 5.511 3.314 3.516 4.97 8.847 4.97 15.995 0 7.15-1.656 12.482-4.97 15.995-3.314 3.515-8.244 5.352-14.791 5.513h-14.88V21.183h14.88zm-2.047 39.519c3.091 0 5.752-.331 7.982-.994 2.228-.662 4.067-1.716 5.512-3.162 1.446-1.446 2.509-3.314 3.193-5.603.682-2.289 1.023-5.04 1.023-8.254 0-3.212-.341-5.964-1.023-8.253-.684-2.29-1.748-4.157-3.193-5.604-1.445-1.446-3.284-2.499-5.512-3.162-2.23-.662-4.891-.994-7.982-.994h-8.737v36.026h8.737zM138.533 21.183l9.76 37.653h.121l10.482-37.653h5.12l10.543 37.653h.121l9.82-37.653h4.096l-11.868 43.014h-4.338l-10.904-38.496h-.121l-10.844 38.496h-4.458l-11.928-43.014h4.398zM190.887 34.195c.843-2.69 2.107-5.07 3.795-7.139 1.687-2.068 3.805-3.714 6.357-4.941 2.549-1.224 5.511-1.837 8.885-1.837 3.374 0 6.326.613 8.856 1.837 2.531 1.227 4.639 2.873 6.325 4.941 1.688 2.069 2.952 4.449 3.796 7.139.843 2.692 1.265 5.523 1.265 8.494 0 2.973-.422 5.806-1.265 8.495-.844 2.69-2.109 5.06-3.796 7.108-1.687 2.049-3.795 3.686-6.325 4.91-2.53 1.225-5.482 1.837-8.856 1.837-3.374 0-6.337-.612-8.885-1.837-2.552-1.224-4.67-2.861-6.357-4.91-1.687-2.049-2.952-4.418-3.795-7.108-.844-2.69-1.265-5.522-1.265-8.495 0-2.971.42-5.802 1.265-8.494zm3.765 15.392c.622 2.27 1.586 4.298 2.892 6.085 1.304 1.788 2.981 3.224 5.03 4.309 2.049 1.083 4.498 1.626 7.35 1.626 2.852 0 5.292-.543 7.32-1.626 2.027-1.084 3.695-2.52 4.999-4.309 1.307-1.787 2.27-3.815 2.894-6.085a25.97 25.97 0 0 0 .932-6.898c0-2.37-.31-4.678-.932-6.927-.623-2.249-1.587-4.267-2.894-6.055-1.304-1.786-2.972-3.223-4.999-4.307-2.028-1.085-4.468-1.626-7.32-1.626-2.852 0-5.301.541-7.35 1.626-2.049 1.084-3.726 2.521-5.03 4.307-1.306 1.788-2.27 3.806-2.892 6.055a25.787 25.787 0 0 0-.934 6.927c0 2.33.31 4.63.934 6.898zM239.442 21.183v39.519h24.098v3.495h-28.194V21.183h4.096zM271.793 21.183v39.519h24.098v3.495h-28.194V21.183h4.096z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M316.014 21.183l16.867 43.014h-4.398l-5.242-13.374h-19.579l-5.181 13.374h-4.337l17.29-43.014h4.58zm5.842 26.145l-8.313-22.049-8.615 22.049h16.928z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 2.482,
  y1: 77.792,
  x2: 73.968,
  y2: 6.306
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#f3904a"
}), React.createElement("stop", {
  offset: 0.999,
  stopColor: "#aa437f"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M72.726 19.497L40.118.671a5.007 5.007 0 0 0-5.006 0L2.503 19.497A5.006 5.006 0 0 0 0 23.833v37.652c0 1.789.954 3.442 2.503 4.336l32.608 18.826a5.007 5.007 0 0 0 5.006 0l32.608-18.826a5.006 5.006 0 0 0 2.503-4.336V23.833a5.003 5.003 0 0 0-2.502-4.336zM16.238 33.246v21.755L5.007 61.485V23.833L37.615 5.007v13.007L18.742 28.91a5.007 5.007 0 0 0-2.504 4.336zm18.873 5.077a5.006 5.006 0 0 0-2.503 4.336v21.679l-11.363 6.56V33.246L53.853 14.42v13.083l-18.742 10.82zm35.111 23.162L37.615 80.311V42.659l32.608-18.826-.001 37.652z",
  fill: "url(#SVGID_1_)"
});

var SvgDwollaLogoFullColor = function SvgDwollaLogoFullColor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 332.881 85.318",
    preserveAspectRatio: "xMinYMid meet",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDwollaLogoFullColor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dwolla-logo-full-color.36ed9a02.svg";
export { ForwardRef as ReactComponent };